export default __webpack_public_path__ + "static/media/3985 - BAYC3593.50d04ac0.jpeg";